import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetPodcast = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['title'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    if(is_paginate==1){
        params['paginate'] = is_paginate;
    }

    const response = await GET(apiUrl.podcast, params);
    return response;
}

export const GetPodcastById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.podcast + '/' + id,params);
    return response;
}

export const CreatePodcast = async (data) => {
    const response = await POST(apiUrl.podcast, data);
    return response;
}

export const UpdatePodcast = async (id, data) => {
    const response = await PUT(apiUrl.podcast, id, data);
    return response;
}

export const DeletePodcast = async (id) => {
    const response = await DELETE(apiUrl.podcast, id);
    return response;
}
